export const UPDATE_COMMENT_BY_TARGET_ACTUAL_FAILURE = 'UPDATE_COMMENT_BY_TARGET_ACTUAL_FAILURE';

export const updateCommentByTargetActualFailure = error => ({
    type: UPDATE_COMMENT_BY_TARGET_ACTUAL_FAILURE,
    payload: error,
    error: true,
});
